// src/common/util/helpDocsLighthouse/destroyHelpDocsWidget.ts
export function destroyHelpDocsWidget() {
  if (typeof window === "undefined") {
    return;
  }

  // 1) Remove any Lighthouse loader scripts
  const scripts = Array.from(
    document.querySelectorAll<HTMLScriptElement>(
      // eslint-disable-next-line
      'script[src^="https://lighthouse.helpdocs.io/load"]',
    ),
  );
  for (const s of scripts) {
    s.remove();
  }

  // 2) Clear the global config
  //    (so if you re-initialize later, it's fresh)
  delete window.hdlh;

  // 2b) Remove our fake-Intercom bridge (never a real integration)
  if (window.Intercom?.isWixarpediaStub) {
    delete window.Intercom;
  }

  // 3) Remove the widget container
  const widgetEl = document.getElementById("lighthouse");
  if (widgetEl && widgetEl.parentNode) {
    widgetEl.parentNode.removeChild(widgetEl);
  }
}
